<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/intake'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
    :ref="'console-season-year'"
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import { SplitViewService } from "../../../_services/api/templates/split-view.services";
import { IntakeSeasonService } from "../../../_services/api/settings/inventory/intake-season.service";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        ConsoleName: null,
        SeasonYear: null,
        Inactive: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Console Season Year",
        pageRoute: "/console-season-year",
        saveEndPoint: "AlmondcoConsoleYears",
        updateEndPoint: "AlmondcoConsoleYears",
        recordEndPoint: "AlmondcoConsoleYears",
        exportFileName: "Console Season Year List",
        notice: "Applies to Production Console Software ONLY.",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoConsoleYears",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              sort: [{ selector: "ConsoleName", desc: false }],
              postProcessCallback: this.consoleSeasonYearPostProcessCallback,
            },
            rowSelect: {
              view: this,
              page: "console-season-year",
              mode: "review",
              idProperty: "RecordId",
              idMode: "Guid",
              rowSelectCallBack: () => {
                this.beforeInit();
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/console-season-year/create",
                clickAction: () => {
                  this.goToCreateConsoleSeasonYear();
                },
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "AlmondcoConsoleSeasonYear",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "ConsoleName",
              label: "Console Name",
              dataField: "ConsoleName",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
            },
            {
              screenField: "SeasonYear",
              label: "Season Year",
              dataField: "SeasonYear",
            },
            {
              screenField: "DateChanged",
              label: "Last Changed",
              dataField: "DateChanged",
              dataType: "date",
              dateVariant: "UTC",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: this.setSaveOption,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "ConsoleName",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 1,
                  maxLength: 63,
                  hint: "Must exactly match the name this device posts as its transaction source — a mismatched name will not apply this override.",
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Console Name" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
              },
              {
                dataField: "SeasonYear",
                editorType: "dxSelectBox",
                required: true,
                editorOptions: {
                  tabIndex: 2,
                  dataSource: IntakeSeasonService.dataSourceConfig(
                    "api/AlmondcoIntakeSeasonList",
                    {
                      select: [
                        "Season",
                        "SeasonAsString",
                        "RecordId",
                        "StartDate",
                        "EndDate",
                      ],
                      sort: "Season asc",
                    }
                  ),
                  displayExpr: "Season",
                  valueExpr: "Season",
                  searchExpr: ["SeasonAsString"],
                  searchMode: "contains",
                  showClearButton: true,
                  searchEnabled: true,
                  dropDownOptions: {
                    minWidth: 200,
                  },
                  onValueChanged: this.onSeasonYearValueChanged,
                },
                label: { text: "Season Year" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
    setSaveOption() {
      return FeatureStorage.checkPermission(
        this.$route.meta.applicationFeatureCode,
        "create"
      );
    },
  },
  methods: {
    goToCreateConsoleSeasonYear() {
      this.$router
        .push({
          path: `/console-season-year/create`,
        })
        .then(() => {
          this.beforeInit();
        });
    },
    async beforeInit() {
      this.recordEditable = true;
      if (this.baseView.mode === "create") {
        await this.setDefaultSeasonYear();
      }
    },
    async setDefaultSeasonYear() {
      await SplitViewService.getItems({
        url: "api/AlmondcoIntakeSeason",
        select: "Season,StartDate,EndDate",
      }).then((res) => {
        if (res && res.data && res.data.value) {
          const today = new Date();
          const currentSeason = res.data.value.find(
            (season) =>
              new Date(season.StartDate) <= today &&
              today <= new Date(season.EndDate)
          );
          if (currentSeason) this.formModel.SeasonYear = currentSeason.Season;
        }
      });
    },
    async onSeasonYearValueChanged(e) {
      if (this._revertingSeasonYear) {
        this._revertingSeasonYear = false;
        return;
      }

      // Only gate a user-driven change (e.event is only set for a real
      // interaction, never a programmatic/initial-load value set) to an
      // *existing* row's Season Year — not first-time creation.
      if (
        e.event &&
        this.baseView.mode === "edit" &&
        e.previousValue != null &&
        e.value !== e.previousValue
      ) {
        const confirmed = await this.$confirm(
          `Changing the Season Year for console <b>${this.formModel.ConsoleName}</b> from <b>${e.previousValue}</b> to <b>${e.value}</b> will change which season all future automated bin transactions from this physical console are attributed to. Are you sure you want to continue?`,
          "Change Season Year"
        );

        if (!confirmed) {
          this._revertingSeasonYear = true;
          e.component.option("value", e.previousValue);
        }
      }
    },
    consoleSeasonYearPostProcessCallback(data) {
      data.forEach((element) => {
        if (element.DateChanged)
          element.DateChanged = element.DateChanged.dateWithOffset();
      });
      return data;
    },
    overWritePayload(payload) {
      return payload;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
